import { Box, Button } from "@chakra-ui/react";
import React from "react";
import { BiHomeAlt } from "react-icons/bi";
import { Link } from "react-router-dom";

export default function FooterButton({ name, Icon, link }) {
  console.log(window.location.pathname);
  return (
    <Link to={link} reloadDocument>
      <Button
        variant="ghost"
        colorScheme={link === window.location.pathname && "blue"}
      >
        <Box display="flex" flexDir="column" alignItems="center" gap={1}>
          <Icon size={30} />
          {name}
        </Box>
      </Button>
    </Link>
  );
}
